import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {AgencyMasterService} from '../../services/agency-master/agency-master.service';
import {LoadingService} from '../../services/loading/loading.service';
import {CarrierService} from '../../services/carrier/carrier.service';
import {OrganizationuserService} from '../../services/organizationuser/organizationuser.service';
import {AgencyMaster, Carrier} from '../../shared/common-components/common-structure';
import {CustomerOrganization} from './agencytspsearch';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {AlertService} from '../../services/alert/alert.service';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {Router} from '@angular/router';
import AppConstants, {BusinessType, CarrierApprovalInfo} from '../../shared/common-components/AppConstants';
import {first, filter, takeWhile} from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { User } from 'src/app/services/user/user';
import { UserService } from 'src/app/services/user/user.service';

@Component({
    selector: 'app-agencytspsearch',
    templateUrl: './agencytspsearch.component.html',
    styleUrls: ['./agencytspsearch.component.css'],
    standalone: false
})
export class AgencytspsearchComponent implements OnInit, OnDestroy {
  searchFor: string[] = [
    'Freight TSP',
    'Freight Agency Customers',
    'HouseHold Goods TSP',
    'HouseHold Goods Agency Customers',
    'User'
  ];
  searchForFrt: string[] = [
    'Freight TSP',
    'Freight Agency Customers',
    'User'
  ];
  searchForHHG: string[] = [
    'HouseHold Goods TSP',
    'HouseHold Goods Agency Customers',
    'User'
  ];
  private observer$ = new BehaviorSubject(true);
  HHG = BusinessType.HHG;
  FRT = BusinessType.FRT;
  HHG_FRT = BusinessType.HHG_FRT;
  currentUser: User;
  searchList: string[] = [];
  carrier: string[] = [
    'SCAC',
    'TSP Name'
  ];
  userFilter: string[] = [
    'Agency',
    'Carrier'
  ];
  showCreateAgency: Boolean = false;
  showNoCarriers = false;
  results: Boolean = false;
  frtHhgCarrier: Boolean = false;
  frtHhgAgencyCustomers: Boolean = false;
  userCustomer: Boolean = false;
  showFrtHhgCarrierTable: Boolean = false;
  showFrtHhgAgencyCustomers: Boolean = false;
  showUserCustomer: Boolean = false;

  minLengthToSearch: number;
  maxCharLength: number;
  agencyCustomerList: AgencyMaster[];
  agencyBureauList: AgencyMaster[];
  agencySearchList: CustomerOrganization[];
  agencySearchListMaster: CustomerOrganization[] = [];
  agencyCode: string;
  bureauCode: string;
  scacCodeList: string[] = [];
  scacNameList: string[] = [];
  typeaheadlist: string[];
  carrierSearchList: Carrier[];
  businessType: string;
  organizationUser: any;
  organizationStatus: any;
  emailId: string;
  /*organizationId: number;*/
  /*userId: number;*/
  keywordDisabled = true;
  agencyMasterId: number;
  /*isAgency = 'false';*/

  // Pagination Variables
  itemsPerPage = 10;
  totalItems = 0;
  currentPage = 1;
  pageReset = false;
  previousPage = 0;
  resultsPage: any = null;
  pageMap: Map<number, any> = new Map<number, any>();
  showingStart: number;
  showingEnd: number;

  modalRef: BsModalRef;

  agencyTspSearchGroup: UntypedFormGroup;
  agencyColumnDefs = [
    {
      headerName: 'Location',
      cellRenderer: params => {
        if (AppConstants.isNotNullCondition(params) && (params.data.organizationStatus === 'Active')) {
          return '<a tabindex="0">' + params.data.agencyLocation + '</a>';
        } else {
          return params.data.agencyLocation;
        }
      }, onCellClicked: params => (params.data.organizationStatus === 'Active') ? this.onLocationClicked(params) : null
      , filter: 'agTextColumnFilter', sortable: true
    },
    /*{ headerName: 'Workgroup ID', field: 'workGroup', filter: 'agTextColumnFilter', sortable: true },*/
    {headerName: 'Customer Location ID', field: 'organizationId', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Authorized Official', field: 'contactName', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Phone Number', field: 'phone', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Email', field: 'contactEmail', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Status', field: 'organizationStatus', filter: 'agTextColumnFilter', sortable: true}
  ];

  domLayout;

  /**
   * @description injects all the static dependencies used in the component.
   */
  constructor(private fb: UntypedFormBuilder, public loader: LoadingService, private agencyMasterService: AgencyMasterService,
              private carrierService: CarrierService, private modalService: BsModalService,
              private organizationUserService: OrganizationuserService, private alertService: AlertService, private router: Router,
              private userService: UserService) {
  }
  ngOnDestroy(): void {
    this.observer$.next(false);
  }

  /**
   * @description initializes agencytspsearch form
   */
  initializeForm() {
    this.agencyTspSearchGroup = this.fb.group({
      searchCriteria: new UntypedFormControl('', Validators.required),
      carrierSearchCriteria: new UntypedFormControl('', Validators.required),
      carrierKeyword: new UntypedFormControl('', Validators.required),
      agencyName: new UntypedFormControl('', Validators.required),
      agencyCode: new UntypedFormControl(''),
      bureauName: new UntypedFormControl('', Validators.required),
      email: new UntypedFormControl('', Validators.required)
    });
    this.agencyTspSearchGroup.get('searchCriteria').valueChanges.subscribe(searchCriteria =>
      searchCriteria ? this.onSearchCriteriaChange(searchCriteria) : null);
    this.agencyTspSearchGroup.get('carrierSearchCriteria').valueChanges.subscribe(searchCriteria => {
      this.agencyTspSearchGroup.get('carrierKeyword').setValue(null);
      if (searchCriteria !== null) {
        this.onCarrierSearchCriteriaChange(searchCriteria);
      }
    });
    this.agencyTspSearchGroup.get('agencyCode').valueChanges
      .pipe(filter(agencyCode => agencyCode && agencyCode != null))
      .subscribe(agencyCode => this.onCustomerNameChange(agencyCode));
    this.agencyTspSearchGroup.get('bureauName').valueChanges
      .pipe(filter(bureauName => bureauName && bureauName != null))
      .subscribe(bureauCode => this.onBureauNameChange(bureauCode));
  }

  /**
   * @description initializes the agencytspsearch form
   */
  ngOnInit() {
    this.domLayout = 'autoHeight';
    this.initializeForm();
    this.userService.getCurrentUserObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.currentUser = currentUser;
      console.log(this.currentUser);
      this.searchList = this.currentUser.permissions === this.HHG ? this.searchForHHG : this.currentUser.permissions === this.FRT ?
        this.searchForFrt : this.searchFor;
    });
  }

  compareAgencyNameFn(c1, c2) {
    return c1 && c2 ? c1.agencyCode === c2.agencyCode : c1 === c2;
  }

  compareBureauNameFn(c1, c2) {
    return c1 && c2 ? c1.bureauCode === c2.bureauCode : c1 === c2;
  }

  /**
   * @description listens to changes in the search criteria and show the dropdowns accordingly. Also, clears the form values and forms validators accoridng to the search criteria
   */
  onSearchCriteriaChange(searchCriteriaValue: string) {
    this.frtHhgCarrier = false;
    this.frtHhgAgencyCustomers = false;
    this.userCustomer = false;
    this.showCreateAgency = false;
    this.results = false;
    // this.agencyTspSearchGroup.controls['carrierSearchCriteria'].setValue('');
    // this.agencyTspSearchGroup.controls['carrierKeyword'].setValue('');
    // this.agencyTspSearchGroup.controls['agencyName'].setValue('');
    // this.agencyTspSearchGroup.controls['bureauName'].setValue('');
    this.scacCodeList = [];
    this.scacNameList = [];
    this.agencyTspSearchGroup.controls['email'].setValue('');
    const searchCriteria = this.agencyTspSearchGroup.get('searchCriteria').value;
    if (searchCriteria === 'Freight TSP' || searchCriteria === 'HouseHold Goods TSP') {
      this.frtHhgCarrier = true;
      this.agencyTspSearchGroup.get('agencyName').clearValidators();
      this.agencyTspSearchGroup.get('agencyName').reset('', {emitEvent: false});
      this.agencyTspSearchGroup.get('email').clearValidators();
      this.agencyTspSearchGroup.get('email').reset('', {emitEvent: false});
      this.agencyTspSearchGroup.get('bureauName').clearValidators();
      this.agencyTspSearchGroup.get('bureauName').reset('', {emitEvent: false});
      this.agencyTspSearchGroup.controls['carrierSearchCriteria'].setValidators([Validators.required]);
      this.agencyTspSearchGroup.controls['carrierKeyword'].setValidators([Validators.required]);
      if (searchCriteria === 'Freight TSP') {
        this.businessType = BusinessType.FRT;
      } else if (searchCriteria === 'HouseHold Goods TSP') {
        this.businessType = BusinessType.HHG;
      }
      this.loader.show();
      this.carrierService.getAllCarrierListByBusinessType(this.businessType).subscribe(carrierList => {
        for (const carrierOutput of carrierList) {
          this.scacCodeList.push(carrierOutput.scac);
          this.scacNameList.push(carrierOutput.scacName);
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving HHG TSP User List');
      });
    } else if (searchCriteria === 'Freight Agency Customers' || searchCriteria === 'HouseHold Goods Agency Customers') {
      this.frtHhgAgencyCustomers = true;
      this.agencyTspSearchGroup.get('carrierSearchCriteria').clearValidators();
      this.agencyTspSearchGroup.get('carrierSearchCriteria').reset('', {emitEvent: false});
      this.agencyTspSearchGroup.get('carrierKeyword').clearValidators();
      this.agencyTspSearchGroup.get('carrierKeyword').reset('', {emitEvent: false});
      this.agencyTspSearchGroup.get('email').clearValidators();
      this.agencyTspSearchGroup.get('email').reset('', {emitEvent: false});
      this.agencyTspSearchGroup.controls['agencyName'].setValidators([Validators.required]);
      this.agencyTspSearchGroup.controls['bureauName'].setValidators([Validators.required]);
      if (searchCriteriaValue === 'Freight Agency Customers') {
        this.businessType = 'FRT';
      } else if (searchCriteriaValue === 'HouseHold Goods Agency Customers') {
        this.businessType = 'HHG';
      }
      if (!this.agencyCustomerList) {
        this.loader.show();
        this.agencyMasterService.getAllAgency().subscribe(allAgencies => {
          this.agencyCustomerList = allAgencies;
          this.loader.hide();
        }, error => {
          this.loader.hide();
          this.alertService.error('There was an error retrieving Agency User List');
        });
      }
    } else if (searchCriteria === 'User') {
      this.userCustomer = true;
      this.agencyTspSearchGroup.get('carrierSearchCriteria').clearValidators();
      this.agencyTspSearchGroup.get('carrierSearchCriteria').reset('', {emitEvent: false});
      this.agencyTspSearchGroup.get('carrierKeyword').clearValidators();
      this.agencyTspSearchGroup.get('carrierKeyword').reset('', {emitEvent: false});
      this.agencyTspSearchGroup.get('agencyName').clearValidators();
      this.agencyTspSearchGroup.get('agencyName').reset('', {emitEvent: false});
      this.agencyTspSearchGroup.get('bureauName').clearValidators();
      this.agencyTspSearchGroup.get('bureauName').reset('', {emitEvent: false});
      this.agencyTspSearchGroup.controls['email'].setValidators([Validators.required, Validators.email]);
    }
  }

  typeaheadAgencyOnSelect(e: TypeaheadMatch) {
    this.agencyTspSearchGroup.get('agencyName').setValue(e.item.agencyBureauName + ' - ' + e.item.agencyCode);
    this.agencyTspSearchGroup.get('agencyCode').setValue(e.item.agencyCode);
    this.agencyTspSearchGroup.get('bureauName').setValue(null);
  }

  /**
   * @description User selected Freight Carrier/Household Goods search criteria. Defining properties for typeahead feature
   */
  onCarrierSearchCriteriaChange(carrierSearchCriteriaValue: string) {
    this.showCreateAgency = false;
    this.results = false;
    this.keywordDisabled = false;
    // this.agencyTspSearchGroup.controls['carrierKeyword'].setValue(null);
    if (carrierSearchCriteriaValue === 'SCAC') {
      // clear keyword text field
      this.minLengthToSearch = 1;
      this.maxCharLength = 4;
      // Set scacCodeList for typeahead
      this.typeaheadlist = this.scacCodeList;
    } else if (carrierSearchCriteriaValue === 'TSP Name') {
      // clear keyword text field
      this.minLengthToSearch = 3;
      this.maxCharLength = 60;
      // Set scacNameList for typeahead
      this.typeaheadlist = this.scacNameList;
    }
  }

  /**
   * @description when user selects the agency gets all the bureaus for the selectes agency
   */
  onCustomerNameChange(agencyCodeValue: string) {
    this.showCreateAgency = false;
    this.results = false;
    // this.agencyTspSearchGroup.controls['bureauName'].setValue('');
    if (agencyCodeValue !== null) {
      this.agencyCode = agencyCodeValue;
      this.loader.show();
      this.agencyMasterService.getAllBureauByAgency(this.agencyCode).subscribe(allBureau => {
        this.agencyBureauList = allBureau;
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving Agency Bureau List: ' + error);
      });
    }
  }

  /**
   * @description User selected Agency & Bureau from the Customer List. Get all Agency Bureau users for selected
   */
  onBureauNameChange(bureauCodeValue: string) {
    this.showCreateAgency = false;
    this.results = false;
    if (bureauCodeValue !== null) {
      // User selected Bureau from the Bureau List
      this.bureauCode = bureauCodeValue;
    }
    this.loader.show();
    this.agencyMasterService.getAgencyUsersByAgencyCodeAndBureauCode(this.agencyCode, this.bureauCode).subscribe(allBureau => {
      // this.agencySearchList = allBureau;
      this.agencySearchListMaster = allBureau;
      if (this.agencySearchListMaster.length === 1) {
        if (this.agencySearchListMaster[0].agencyBureau === null || this.agencySearchListMaster[0].agencyBureau === '') {
          this.agencySearchList = [];
        } else {
          this.agencySearchList = this.agencySearchListMaster;
        }
      } else {
        this.onTypeChange();
      }
      this.loader.hide();
      if (this.agencySearchListMaster.length !== 0) {
        this.agencyMasterId = this.agencySearchListMaster[0].agencyMasterId;
      } else {
        this.agencyMasterId = null;
      }
      // This code is to check if no Agency Customers backend API will just send Master ID so reinitialize the array
    }, error => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving Agency Bureau List: ' + error);
    });
  }

  onTypeChange() {
    if (this.agencySearchListMaster.length !== 0) {
      if (this.agencyTspSearchGroup.get('searchCriteria').value === 'Freight Agency Customers') {
        this.agencySearchList = this.agencySearchListMaster.filter(x => x.businessType.indexOf('FRT') !== -1);
      } else if (this.agencyTspSearchGroup.get('searchCriteria').value === 'HouseHold Goods Agency Customers') {
        this.agencySearchList = this.agencySearchListMaster.filter(x => x.businessType.indexOf('HHG') !== -1);
      }
    } else {
      this.agencySearchList = [];
    }
  }

  search() {
    this.results = true;
    this.showCreateAgency = true;
    this.showFrtHhgCarrierTable = false;
    this.showFrtHhgAgencyCustomers = false;
    this.showUserCustomer = false;
    this.showNoCarriers = false;
    this.agencyMasterService.agencyMasterFormState.next(this.agencyTspSearchGroup.value);
    if (this.agencyTspSearchGroup.get('searchCriteria').value === 'Freight TSP' || this.agencyTspSearchGroup.get('searchCriteria').value === 'HouseHold Goods TSP') {
      if (this.agencyTspSearchGroup.get('carrierSearchCriteria').value === 'SCAC') {
        // User selected SCAC search criteria. Get all SCACs by ScacExt
        this.loader.show();
        this.carrierService.getAllCarrierScacCodeList(this.agencyTspSearchGroup.get('carrierKeyword').value, this.businessType).subscribe(carrierSearch => {
          if (AppConstants.isNotNullCondition(carrierSearch)) {
            this.carrierSearchList = carrierSearch;
            this.onAssignMessage();

            this.showFrtHhgCarrierTable = this.carrierSearchList.length !== 0 ? true : false;
            this.showNoCarriers = this.carrierSearchList.length === 0 ? true : false;
            this.totalItems = this.carrierSearchList.length;
            this.setupPagination();
          }
          this.loader.hide();
        }, error => {
          this.showFrtHhgCarrierTable = false;
          this.results = false;
          this.loader.hide();
          this.alertService.error('There was an error retrieving Carrier List');
        });
      } else if (this.agencyTspSearchGroup.get('carrierSearchCriteria').value === 'TSP Name') {
        // User selected Carrier Name search criteria. Get all Carrier Name by ScacExt
        this.loader.show();
        this.carrierService.getAllCarrierScacNameList(this.agencyTspSearchGroup.get('carrierKeyword').value, this.businessType).subscribe(carrierSearch => {
          if (AppConstants.isNotNullCondition(carrierSearch)) {
            this.carrierSearchList = carrierSearch;
            this.onAssignMessage();
            this.showFrtHhgCarrierTable = this.carrierSearchList.length !== 0 ? true : false;
            this.showNoCarriers = this.carrierSearchList.length === 0 ? true : false;
            this.totalItems = this.carrierSearchList.length;
            this.setupPagination();
          }
          this.loader.hide();
        }, error => {
          this.showFrtHhgCarrierTable = false;
          this.results = false;
          this.loader.hide();
          this.alertService.error('There was an error retrieving TSP List: ' + error);
        });
      }
    } else if (this.agencyTspSearchGroup.get('searchCriteria').value === 'Freight Agency Customers' || this.agencyTspSearchGroup.get('searchCriteria').value === 'HouseHold Goods Agency Customers') {
      this.showFrtHhgAgencyCustomers = true;
      this.totalItems = this.agencySearchList.length;
      this.setupPagination();
    } else if (this.agencyTspSearchGroup.get('searchCriteria').value === 'User') {
      this.showCreateAgency = false;
      this.emailId = this.agencyTspSearchGroup.get('email').value;
      this.loader.show();
      this.organizationUserService.getOrganizationUserByEmail(this.emailId).subscribe(userlookup => {
        this.loader.hide();
        if (AppConstants.isNotNullCondition(userlookup)) {
          this.organizationUser = userlookup;
          this.showUserCustomer = true;
          this.showCreateAgency = false;
        } else {
          this.showUserCustomer = false;
          this.alertService.info('The Email is not in the system');
        }
      }, error => {
        this.loader.hide();
        this.results = false;
        this.alertService.error('There was an error retrieving User with given email');
      });

    }
  }

  onAssignMessage(){
    this.carrierSearchList.forEach(carrier => {
        if (carrier.carrierApprovalInformationEntity.length > 0) {
          carrier.carrierApprovalInformationEntity.forEach(approvalEntity => {
            if(approvalEntity.approvalDate === null && approvalEntity.suspendedDate === null && approvalEntity.revokedDate === null){
              carrier[approvalEntity.approvalType] = 'Not yet Approved';
            }else{
              const arrDate = [
                {
                  id:1,
                  date: (approvalEntity.approvalDate === null) ? new Date(0) : new Date(approvalEntity.approvalDate)
                }, {
                  id:2,
                  date: (approvalEntity.suspendedDate === null) ? new Date(0) : new Date(approvalEntity.suspendedDate)
                }, {
                  id:3,
                  date:  (approvalEntity.revokedDate === null) ? new Date(0) : new Date(approvalEntity.revokedDate)
                }
              ];
              const latestDate = arrDate.reduce((a, b) => a.date > b.date ? a : b);
              switch(latestDate.id) {
                case 1://approval Date
                  if (approvalEntity.approvalDate === null) {
                    carrier[approvalEntity.approvalType] = 'Not yet Approved';
                  } else {
                    const date_format = new Date(approvalEntity.approvalDate);
                    carrier[approvalEntity.approvalType] = 'Approved on ' + (date_format.getMonth() + 1) + '/' + date_format.getDate() + '/' + date_format.getFullYear();
                  }
                  break;
                case 2:
                  const date_format_suspended = new Date(approvalEntity.suspendedDate);
                  carrier[approvalEntity.approvalType] = 'Temp Non-Use on ' + (date_format_suspended.getMonth() + 1) + '/' + date_format_suspended.getDate() + '/' + date_format_suspended.getFullYear();
                  break;
                case 3:
                  const date_format_revoked = new Date(approvalEntity.revokedDate);
                  carrier[approvalEntity.approvalType] = 'Revoked on ' + (date_format_revoked.getMonth() + 1) + '/' + date_format_revoked.getDate() + '/' + date_format_revoked.getFullYear();
                  break;
                default:
                  break;
              }
            }
          });
        }
      }
    );
  }

  delete(carrier: Carrier) {
    if (carrier.carrierId !== null) {
      // User clicked Delete from the TSP User List
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to delete this User?';
      this.modalRef.content.title = 'USER DELETE';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          this.loader.show();
          this.carrierService.deleteCarrierUser(carrier.carrierId).subscribe(response => {
            const indexForCarrierSearch = this.carrierSearchList.indexOf(carrier);
            this.carrierSearchList.splice(indexForCarrierSearch, 1);
            const indexForScac = this.scacCodeList.indexOf(carrier.scac);
            this.scacCodeList.splice(indexForScac, 1);
            const indexForScacname = this.scacCodeList.indexOf(carrier.scac);
            this.scacCodeList.splice(indexForScacname, 1);
            this.setupPagination();
            this.loader.hide();
            this.alertService.info(response.response);
          }, error => {
            this.loader.hide();
            console.log('There was an error deleting carrier');
            this.alertService.error('There was an error deleting carrier: ' + error);
          });
        }
      });
    }
  }

  onLocationClicked(params) {
    this.router.navigate(['/agencyprofile'],
      {queryParams: {orgId: params.data.organizationId, agybur: params.data.agencyBureau}});
  }

  // Set Up Pagination Map
  setupPagination() {
    this.pageMap = new Map<number, any>();
    let pageCount = 1;
    const filteredtAgencyList = new Array;
    if (this.agencyTspSearchGroup.get('searchCriteria').value === 'Freight Agency Customers') {
      this.agencySearchList.forEach(function (agency) {
        if (agency.businessType === 'FRT' || agency.businessType === 'HHG & FRT') {
          filteredtAgencyList.push(agency);
        }
      });
    } else if (this.agencyTspSearchGroup.get('searchCriteria').value === 'HouseHold Goods Agency Customers') {
      this.agencySearchList.forEach(function (agency) {
        if (agency.businessType === 'HHG' || agency.businessType === 'HHG & FRT') {
          filteredtAgencyList.push(agency);
        }
      });
    }
    for (let i = 0; i < this.totalItems; i = i + this.itemsPerPage) {
      if (this.agencyTspSearchGroup.get('searchCriteria').value === 'Freight TSP' || this.agencyTspSearchGroup.get('searchCriteria').value === 'HouseHold Goods TSP') {
        const pageOfAgencyTspSearch = this.carrierSearchList.slice(i, i + this.itemsPerPage);
        this.pageMap.set(pageCount, pageOfAgencyTspSearch);
      } else if (this.agencyTspSearchGroup.get('searchCriteria').value === 'Freight Agency Customers' || this.agencyTspSearchGroup.get('searchCriteria').value === 'HouseHold Goods Agency Customers') {
        const pageOfAgencyTspSearch = filteredtAgencyList.slice(i, i + this.itemsPerPage);
        this.pageMap.set(pageCount, pageOfAgencyTspSearch);
      }

      pageCount++;
    }
    // Reset the current page to the first page
    this.currentPage = 1;
    this.resultsPage = this.pageMap.get(this.currentPage);
    this.showingStart = 1;
    const end = this.currentPage * this.itemsPerPage;
    if (end > this.totalItems) {
      this.showingEnd = this.totalItems;
    } else {
      this.showingEnd = end;
    }
  }

  page(currentPage: number) {
    this.currentPage = currentPage;
    if (this.resultsPage != null && this.resultsPage.length !== 0) {
      this.resultsPage = this.pageMap.get(currentPage);
    }
    const end = this.currentPage * this.itemsPerPage;
    if (end > this.totalItems) {
      this.showingEnd = this.totalItems;
    } else {
      this.showingEnd = end;
    }
    this.showingStart = (this.currentPage * this.itemsPerPage) - this.itemsPerPage + 1;
  }

  itemsPerPageChanged(itemsPerPage: any) {
    this.itemsPerPage = itemsPerPage;
    if (this.resultsPage != null && this.resultsPage.length !== 0) {
      this.setupPagination();
      this.pageReset = true;
    }
  }

  clickOnUser(orgUser) {
    // TODO remove this code once the API is fixed to get isAgencyUser true
    let isAgencyUser;
    if (AppConstants.isNotNullCondition(orgUser.organizationId)) {
      if (orgUser.roleId === 3 || orgUser.roleId === 2 || orgUser.roleId === 7) {
        isAgencyUser = true;
      } else {
        isAgencyUser = false;
      }
      this.router.navigate(['/agencyuser'], {
        queryParams: {
          organizationId: orgUser.organizationId,
          isAgencyUser: isAgencyUser, userId: orgUser.userId
        }
      });
    } else {
      this.alertService.info('There is no organization ID associated to this user. Please contact system administrator.');
    }
  }

  goToCarrierProfile(carrier) {
    if (AppConstants.isNotNullCondition(carrier.organizationId)) {
      this.router.navigate(['/carrierprofile'], {
        queryParams: {
          orgId: carrier.organizationId,
          status: carrier.carrierStatus
        }
      });
    } else {
      this.alertService.info('There is no organization ID associated to this TSP. Please contact system administrator.');
    }
  }

  goToAgencyProfile(agency) {
    if (AppConstants.isNotNullCondition(agency.organizationId) && AppConstants.isNotNullCondition(agency.agencyBureau)) {
      this.router.navigate(['/agencyprofile'], {
        queryParams: {orgId: agency.organizationId, agybur: agency.agencyBureau}
      });
    } else {
      this.alertService.info('There is no organization ID/ Bureau associated to this Agency. Please contact system administrator.');
    }
  }

  getOrganization(organization) {
    if (AppConstants.isNotNullCondition(organization)) {
      return organization.agencyCustomerEntity && organization.agencyCustomerEntity.agencyMasterEntity ? organization.agencyCustomerEntity.agencyMasterEntity.agencyBureauName : (organization.carrierEntity ? organization.carrierEntity.scacName : '');
    }
  }

  getUserPermission(organization: any){
    if(AppConstants.isNotNullCondition(organization)){   
      return AppConstants.isNotNullCondition(organization.permission) ? organization.permission : '';
    }else
      return null;
  }

  isValidPermissionForHyperLink(organization: any, orgUser: any){
    if(AppConstants.isNotNullCondition(organization) && AppConstants.isNotNullCondition(organization.permission)){
      if(this.currentUser.permissions === BusinessType.HHG_FRT){return true;
      }else{
        if(organization.permission === this.currentUser.permissions) return true;
        else return false;
      }
    }else
      return false;
  }

  onFirstDataRendered(params) {
    params.api.sizeColumnsToFit();
  }
}
